import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, computed, inject, signal } from '@angular/core';
import { UserProfile } from '@app/core/models';
import { NavDataService, RolesService } from '@app/core/services';
import { AuthSessionService } from '@app/core/services/auth-session/auth-session.service';
import { CrispChatService } from '@app/core/services/crisp-chat/crisp-chat.service';
import { MembershipService } from '@app/core/services/membership/membership.service';
import { ModalManagerService } from '@app/core/services/modal-manager';
import { environment } from '@env/environment';

@Component({
  selector: 'membership-info-button',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './membership-info-button.component.html',
  styleUrls: ['./membership-info-button.component.scss'],
})
export class MembershipInfoButtonComponent {
  @Input() baseCssClass?: string;
  @Input() isBtn = false;
  membershipPlanLevel = signal<string | undefined>(undefined);
  cssClass = computed(() => {
    if (this.membershipPlanLevel() === '' && this.isBtn) {
      return this.baseCssClass + ' btn btn-disabled rounded-3';
    } else if (this.membershipPlanLevel() === '' && !this.isBtn) {
      return this.baseCssClass + ' text-white';
    } else {
      return this.baseCssClass + ' text-success py-3';
    }
  });
  roleService = inject(RolesService);
  protected authSessionService: AuthSessionService = inject(AuthSessionService);
  protected modalManagerService: ModalManagerService = inject(ModalManagerService);
  private navDataService = inject(NavDataService);
  private membershipService = inject(MembershipService);
  private readonly crispChatService = inject(CrispChatService);

  constructor() {
    this.authSessionService.currentUserProfile$.subscribe((userProfile: UserProfile | null) => {
      this.membershipPlanLevel.set(
        environment.needD7
          ? userProfile?.current_role.display_name?.split(' ').pop()
          : userProfile?.current_role.display_name
      );
    });
  }

  membershipNavigation() {
    if (this.roleService.userHasNoRoles()) {
      this.crispChatService.openChat();
      return;
    }
    if (this.roleService.userHasRole(['premium', 'plus', 'basic', 'candidate', 'expired'], true)) {
      // prevent access profile billing page on prod builds
      if (!environment.production) {
        this.navDataService.navigate('/profile/billing');
      }
      return;
    }
    this.modalManagerService.toggle();
  }

  renewMembership() {
    this.membershipService.tryToRenew().subscribe();
  }
}
